interface LoadingOverlayProps {
  message?: string;
  submessage?: string;
}

export function LoadingOverlay({ message = 'Processing...', submessage }: LoadingOverlayProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 backdrop-blur-sm">
      <div className="bg-surface rounded-lg p-8 text-center shadow-2xl max-w-md">
        <div className="relative w-20 h-20 mx-auto mb-4">
          <div className="absolute inset-0 border-4 border-accent-100 rounded-full"></div>
          <div className="absolute inset-0 border-4 border-accent-500 rounded-full border-t-transparent animate-spin"></div>
        </div>
        <p className="text-lg font-semibold text-primary mb-2">
          {message}
        </p>
        {submessage && (
          <p className="text-sm text-secondary">
            {submessage}
          </p>
        )}
      </div>
    </div>
  );
}
